export const GOOGLE_MAP_API_KEY = 'AIzaSyAaoOf5FeXgE9qXTkTq2kEjX53tGUy6a8A'
